var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.opened)?_c('div',{staticClass:"fixed inset-0",staticStyle:{"z-index":"700000"},attrs:{"tabindex":"-1"}},[_c(_vm.$store.state.component,_vm._b({tag:"component",attrs:{"close":() => _vm.$store.close()}},'component',_vm.$store.state.data,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }